<template>
  <div>
    <div class="text-3xl mb-8">Rechnungen</div>

    <InvoiceTable />
  </div>
</template>

<script>
import InvoiceTable from "@/components/InvoiceTable";

export default {
  components: { InvoiceTable }
};
</script>